import { Box, Flex, Icon, Pane } from '@fullstory/components';
import React from 'react';
import css from './index.module.scss';

export const WarningBanner: React.FC<Partial<React.ComponentProps<typeof Pane>>> = ({
  children,
  ...paneProps
}) => (
  <Pane
    data-component="IssuesBanner"
    borderRadius={4}
    padding={8}
    testId="issues-banner"
    className={css.issueBanner}
    {...paneProps}
  >
    <Flex justifyContent="space-between" gap={12}>
      <Flex gap={12}>
        <Box>
          <Icon name="warning" color="default" size={16} />
        </Box>
        {children}
      </Flex>
    </Flex>
  </Pane>
);
